import React, { Component } from 'react';

import propTypes from 'prop-types';

import { ProjectLocationDetails } from 'lib/generated_constants/project_location_details';

import { inPersonInterviewInfoShape } from '../project_prop_types';

export class InPersonInterviewInfo extends Component {
  static propTypes = {
    interviewInfo: propTypes.shape(inPersonInterviewInfoShape).isRequired,
  };

  get parkingAdditionalInfo() {
    return this.props.interviewInfo.parkingAdditionalInfo || '';
  }

  get hasParkingAdditionalInfo() {
    return !!this.parkingAdditionalInfo;
  }

  get parkingIsAvailable() {
    return this.props.interviewInfo.parkingIsAvailable || false;
  }

  renderParkingDetails() {
    return <div>Details: {this.parkingAdditionalInfo}</div>;
  }

  renderParkingIsAvailable() {
    return this.parkingIsAvailable
      ? 'Yes, there is parking available to participants.'
      : 'No, parking is not available to participants.';
  }

  render() {
    if (
      this.props.interviewInfo.locationDetail !==
      ProjectLocationDetails.researcherLocation
    ) {
      return null;
    }

    return (
      <>
        <dt>Parking provided</dt>
        <dd>
          <p>{this.renderParkingIsAvailable()}</p>

          {this.parkingIsAvailable && this.hasParkingAdditionalInfo && (
            <p>{this.renderParkingDetails()}</p>
          )}
        </dd>
      </>
    );
  }
}
